var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-voice" }, [
    _c("div", { staticClass: "yxtbizf-speech-container" }, [
      _c(
        "div",
        { staticClass: "yxtbizf-speech bg-primary-6 color-primary-6 mr16" },
        [
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isPlay,
                expression: "isPlay",
              },
            ],
            ref: "container",
            staticClass: "mr12",
            staticStyle: { width: "16px", height: "16px" },
          }),
          _c("yxt-svg", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isPlay,
                expression: "!isPlay",
              },
            ],
            staticClass: "mr12",
            attrs: {
              "remote-url": _vm.mediaPath,
              iconClass: "voice",
              width: "16px",
              height: "16px",
            },
          }),
          _c("span", { staticClass: "font-size-14 color-white" }, [
            _vm._v(_vm._s(_vm.text)),
          ]),
        ],
        1
      ),
      _c(
        "span",
        { staticClass: "color-gray-7 font-size-14" },
        [_vm._t("default"), _vm._v("''")],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }